
export const en = {
  "common": {
    "my-fullname": "Alexey Kuznietsov",
    "page-not-exist": "Page does not exist "
  },
  "menu": {
    "home": "Home",
    "contacts": "Contacts",
    "todos": "Todos",
    "cats": "Cats",
    "quotes": "Quotes",
    "users": "Users"
  },
  "home": {
    "welcome-title": "Welcome to my page!",
    "about-me-title": "About me",
    "skills-title": "Skills",
    "technology": "Technology",
    "confident": "confident",
    "average": "average",
    "beginner": "beginner",
    "soft-skills": "Soft skills",
    "soft-skills-list": "adaptability, communication, creative thinking, critical thinking, positivity, flexibility",
    "english-proficiency": "English proficiency"
  },
  "contacts": {
    "h1-title": "Contacts"
  },
  "todo": {
    "todo-h1": "Todo list",
    "textarea-placeholder": "write your todo here...",
    "search-placeholder": "search todo",
    "add-todo": "Add todo",
    "select-importance-level": "Select importance level",
    "select-difficult-level": "Select difficulty level",
    "low": "Low",
    "under-average": "Under average",
    "average": "Average",
    "high": "High",
    "highest": "Highest",
    "easier": "Easier",
    "easy": "Easy",
    "medium": "Medium",
    "hard": "Hard",
    "very-hard": "Very hard",
    "sort-by": "Sort by",
    "date": "Date",
    "importance": "Importance",
    "difficult": "Difficult",
    "no-todos": "No todos",
    "created": "Created"
  },
  "big-texts": {
    "about-me": "Hello! My name is Alexey, I live in a small town in Ukraine. Due to the lack of job offers in my city, I want to study the profession of a web developer in order to be able to work remotely. I have always been fascinated by the \"magic\" of talking with a machine, when you can learn languages that allow you to do some cool things using a computer and a well-written program. Now I am at the beginning of the road, but I hope to become a professional in web development in the near future, I am ready to put a lot of effort into this."
  }
};